export { default } from './FavoritesList';
